var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-item"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.label),expression:"label"}],staticClass:"label",style:(_vm.usWidth)},[_vm._v(_vm._s(_vm.label))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }